module.exports = __webpack_public_path__ + "onboarding-bad.cf8dc3a23346ebd10f344984e0aa696e.hashedasset.png";